import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import {withStyles} from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress';
import green from '@material-ui/core/colors/green';
import Fab from '@material-ui/core/Fab';
import PlayArrowSharpIcon from '@material-ui/icons/PlayArrowSharp';
import StopSharpIcon from '@material-ui/icons/StopSharp';
import {useDispatch, useSelector} from "react-redux";
import {disableBRAttacksAuthorized, enableBRAttacksAuthorized, setStromboliOff, setStromboliOn} from "../../../actions";
import {Badge} from "reactstrap";
import IntlMessages from "../../../util/IntlMessages";
import {Box, Card, Grid} from "@material-ui/core";
import {BRCustomizedTooltip as Tooltip} from "../accents/BRCustomizedTooltip";
import InfoSharpIcon from "@material-ui/icons/InfoSharp";
import {
  BBBreachRiskSubscriptionBadge,
  BBDisableChildren, bbDoesUserHaveAccessToBreachRiskLevelForEntity, bbFindEntityWithinPortfolioOrSelf,
  isCurrentUserMemberOf
} from "../../../util/bbHelpers";

const styles = theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
  },
  wrapper: {
    margin: theme.spacing(1),
    position: 'relative',
    // textAlign: 'center'
  },
  fabProgress: {
    color: green[500],
    position: 'absolute',
    top: -6,
    left: -6,
    zIndex: 1,
  },
  buttonProgress: {
    color: green[500],
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12,
  },
});

const BRBusinessAttacksAuthorizedControlButton = (props) => {

  const {
    classes,
    // customerId,
    brSubscriptionRequired = "Pro",
    overrideEnabledForAdminsStaff = false,
  } = props;
  const {customerInView, customers, } = useSelector(({customer}) => customer);
  const {entityInView, portfolios, loadingUpdateBRAttacksAuthorized, loadingPortfolios} = useSelector(({breachrisk}) => breachrisk);
  const {authUser} = useSelector(({auth}) => auth);
  const isAdminStaff = isCurrentUserMemberOf(authUser, "admin") || isCurrentUserMemberOf(authUser, "staff")

  const customerIdToUse = customers ? customerInView ? customerInView : null : null;
  const myEntity = bbFindEntityWithinPortfolioOrSelf(entityInView, portfolios, customerIdToUse);

  // console.log("myEntity", myEntity)
  const ownershipVerified = myEntity && myEntity.onboarding_progress && myEntity.onboarding_progress.verified_ownership;

  const isCorrectSubscriptionLevel = myEntity ? myEntity.active_subscription && (myEntity.pro_subscription || myEntity.premium_subscription) : null;
  const isAdministratorForThisEntity = bbDoesUserHaveAccessToBreachRiskLevelForEntity(authUser, "infoLevel4", entityInView);

  //const [loading, setLoading] = useState(null);
  // const [success, setSuccess] = useState(null);
  const [customer, setCustomer] = useState(customers ? customers[customerIdToUse] : null);
  const [isBRAttacksAuthorized, setIsBRAttacksAuthorized] = useState(myEntity && myEntity.settings ? myEntity.settings.active_testing_authorized : null);

  const shouldAllowEnabling = (overrideEnabledForAdminsStaff && isAdminStaff)
      ? true
      : !!(brSubscriptionRequired
          && ownershipVerified
          && isCorrectSubscriptionLevel);

  console.log("BRBusinessAttacksAuthorizedControlButton", "myEntity", myEntity, "ownershipVerified", ownershipVerified, "brSubscriptionRequired", brSubscriptionRequired, "isCorrectSubscriptionLevel", isCorrectSubscriptionLevel, "isAdministratorForEntity", isAdministratorForThisEntity, "shouldAllowEnabling", shouldAllowEnabling);


  const dispatch = useDispatch();

  useEffect(() => {
    // console.log("Br authorize attacks control button. customers", customers, "customerIdToUse", customerIdToUse, "customer", customer, "loadingPortfolios", loadingPortfolios, "portfolios", portfolios, "myEntity", myEntity, "isBRAttacksAuthorized", isBRAttacksAuthorized)
    if (customers && customerIdToUse) {
      //setLoading(false);

      setCustomer(customers[customerIdToUse]);
      if (customer) {
        setIsBRAttacksAuthorized(myEntity && myEntity.settings ? myEntity.settings.active_testing_authorized : null);
      }

    }
  }, [customer, isBRAttacksAuthorized, customerIdToUse, customers, portfolios, loadingPortfolios, myEntity]);

  const handleButtonClick = (event) => {
    if (!loadingUpdateBRAttacksAuthorized[entityInView]) {

      if (customer) {
        if (isBRAttacksAuthorized) {
          console.log("Attempting to set Active Attacks Off for customer ", customers[customerIdToUse])
          dispatch(disableBRAttacksAuthorized({
            customerId: customerIdToUse,
            entityId: entityInView
          }));
        } else {
          console.log("Attempting to set Active Attacks On for customer ", customers[customerIdToUse])
          dispatch(enableBRAttacksAuthorized({
            customerId: customerIdToUse,
            entityId: entityInView
          }));
        }
      }
    }
  };


  const buttonClassname = () => {
    if (!isBRAttacksAuthorized && customers && !loadingUpdateBRAttacksAuthorized[entityInView]) {
    return "bg-bb-risk-medium text-dark"
    } else if (isBRAttacksAuthorized && customers && !loadingUpdateBRAttacksAuthorized[entityInView]) {
      return "bg-bb-risk-lowest text-white"
    } else {
      return "bg-light text-dark"
    }
  };

  return ( <div className={'mb-3'}>

          <Card className={`pt-2 bg-light animated fadeIn animation-duration-5 d-flex flex-row`} style={{borderLeft: "12px solid gray", padding: "3px", paddingTop: "7px"}}>

              <Grid container
                    spacing={0}
                    alignItems="stretch"
                    justifyContent="center"
                    direction="row"
              >
                <Grid item xs={4}>

                  <Box className={classes.wrapper}>
                    <BBDisableChildren
                        isDisabled={shouldAllowEnabling}
                        // brLevelRequired={"infoLevel3"}
                        brSubscriptionRequired = {brSubscriptionRequired ? brSubscriptionRequired : null}
                        ownershipVerified={ownershipVerified}
                        isCompact
                        isButtonSized
                    >
                    <Tooltip title={isBRAttacksAuthorized ? "Disable Penetration Testing" : "Enable Penetration Testing"}>
                      <Fab color="default" id={"penTestingButton"} className={buttonClassname()} onClick={(event) => handleButtonClick(event)}>
                        {isBRAttacksAuthorized ? <StopSharpIcon/> : <PlayArrowSharpIcon/>}
                      </Fab>
                    </Tooltip>
                    {(loadingPortfolios[customerIdToUse] || !customers) && <CircularProgress size={68} className={classes.fabProgress}/>}
                    </BBDisableChildren>
                  </Box>

                  {/*<h5 style={{fontSize: "smaller"}}>Control:</h5>*/}
                </Grid>
                <Grid item xs={8} >
                      <h2 >Penetration Testing</h2>
                      <Box id={"tourBRHighFidelityTesting"}>Status: {(customer &&  !loadingPortfolios[customerIdToUse])
                          ? isBRAttacksAuthorized
                              ? <Badge id={"penTestingBadge"} color="bb-risk-lowest"><IntlMessages id={"badge.cirt.active"}/></Badge>
                              : <Badge id={"penTestingBadge"} color="bb-risk-medium"><IntlMessages id={"badge.cirt.inactive"}/></Badge>
                          : <small> <em>Retrieving...</em></small>
                      }</Box>

                </Grid>
              </Grid>
              <div style={{marginLeft: "auto", marginTop: "-4px", marginRight: "3px"}}>
                {/*<BBModuleIcon includeTooltip module={bbGetModulePropertyFromIdOrName("perimeter", "id")} isActive={bbDoesCustomerHaveAccessToModule(customer, "perimeter")} iconSize={"22px"}/>*/}
                <BBBreachRiskSubscriptionBadge subscriptionLevel={"Pro"} />
              </div>
              <div style={{marginLeft: "auto", marginTop: "-2px"}}>
                <Tooltip title={"Penetration Testing. Allows us to obtain more accurate predictions by actively testing the defenses."}>
                  <InfoSharpIcon style={{fontSize: "20px",}} className={`text-muted`}/>
                </Tooltip>
              </div>

          </Card>

      </div>
  );

}

BRBusinessAttacksAuthorizedControlButton.propTypes = {
  classes: PropTypes.object.isRequired,
  // customerId: PropTypes.string,
  overrideEnabledForAdminsStaff: PropTypes.bool,
  brSubscriptionRequired: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired
};

export default withStyles(styles)(BRBusinessAttacksAuthorizedControlButton);